import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";

interface UploadResultProps {
  uploadSuccess: boolean;
    setShowConfirm: (show: boolean) => void;
    close: () => void;
}

const UploadResult: React.FC<UploadResultProps> = ({ uploadSuccess, setShowConfirm, close }) => {
    const { t } = useTranslation();
  
  return (
    <>
      {" "}
      <div className="flex flex-col items-center gap-8">
        {uploadSuccess ? (
          <>
            <h2 className="text-4xl">{t("courses.fileUpload.fileUploaded") }</h2>
            <p className="text-xl text-center">
            {t("courses.fileUpload.uploadedMsg") }
            </p>
            <p className="text-xl text-center">
            {t("courses.fileUpload.uploadedRefresh") }
            </p>
          </>
        ) : (
          <>
            <h2 className="text-4xl">{t("courses.fileUpload.uploadErrorHeader") }</h2>
            <p className="text-xl">{t("courses.fileUpload.uploadErrorMsg") }</p>
          </>
        )}
        <Button
          className="px-10 cursor-pointer"
          onClick={() => setShowConfirm(false)}
        >
          {t("global.ok") }
        </Button>
      </div>
    </>
  );
};

export default UploadResult;
